import { Button } from "@components/atoms/Button"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Two Column Text Item",
}

export default defineBlock("content/two-column-text-item", (props) => {
  return (
    <div
      className={cn(
        "w-full [&_p]:!w-full [&_p]:!px-0 [&_p]:!mt-0 [&_ul]:!mt-0 [&_ol]:!mt-0",
        !env.admin && "flex flex-col gap-5",
      )}
    >
      <InnerBlocks
        adminClassName="flex flex-col gap-5"
        allowedBlocks={["#inline"]}
        template={[["core/paragraph", { placeholder: "Enter your text here..." }]]}
        orientation="vertical"
      />
    </div>
  )
})
